module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/close-small-ff769768529eeff416ca9b22a83c131c.svg";